var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改训练" : "添加训练",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "title", label: "训练标题" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.title,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "title", $$v)
                  },
                  expression: "formData.title"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "training_time", label: "训练开始时间" }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  "popper-class": "no-atTheMoment",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetime",
                  placeholder: "日期"
                },
                model: {
                  value: _vm.formData.training_time,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "training_time", $$v)
                  },
                  expression: "formData.training_time"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "duration", label: "训练时长(分钟)" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.duration,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "duration", $$v)
                  },
                  expression: "formData.duration"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "is_mandatory", label: "是否强制参加" }
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formData.is_mandatory,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "is_mandatory", $$v)
                    },
                    expression: "formData.is_mandatory"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("是")
                  ]),
                  _c("el-radio", { attrs: { label: 0, border: "" } }, [
                    _vm._v("否")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "content_text", label: "训练内容" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: {
                  type: "textarea",
                  autocomplete: "off",
                  placeholder: "请输入"
                },
                model: {
                  value: _vm.formData.content_text,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "content_text", $$v)
                  },
                  expression: "formData.content_text"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "note", label: "备注信息" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: {
                  type: "textarea",
                  autocomplete: "off",
                  placeholder: "请输入"
                },
                model: {
                  value: _vm.formData.note,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "note", $$v)
                  },
                  expression: "formData.note"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "200px" },
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }